import { Injectable } from "@angular/core";
import { ADynamics365ConnectionHttpService, ApiTestConnectionResult, Dynamics365Connection } from "@coso/connection-forms";
import { Observable, of } from "rxjs";
import { catchError, flatMap } from "rxjs/operators";
import { handleError } from "../utils/handle-error";
import { ConnectionMapperService } from "./connection-mapper.service";
import { Dynamics365ConnectionService } from "./dynamics-365-connection.service";

@Injectable({
  providedIn: "root"
})
export class Dynamics365ConnectionHttpService extends ADynamics365ConnectionHttpService {
  constructor(private d365Connection: Dynamics365ConnectionService, private connectionMapper: ConnectionMapperService) {
    super();
  }

  testConnection(configuration: Dynamics365Connection): Observable<ApiTestConnectionResult> {
    const data = this.connectionMapper.mapFromDynamics365Connection(configuration);
    const instanceId = sessionStorage.getItem("instance-id");
    return this.d365Connection.testConnection(instanceId, data).pipe(
      flatMap((result) => {
        if (result.success) {
          return of({
            isSuccess: true,
            additionalData: result.data
          });
        } else {
          return of({
            isSuccess: false,
            error: result.error
          });
        }
      }),
      catchError((error) => {
        return of({
          isSuccess: false,
          error: handleError(error)
        });
      })
    );
  }
}
